import React from 'react';
import PropTypes from 'prop-types';

export default class Header extends React.PureComponent {
  render() {
    const { isEditMode, isMigrateMode } = this.props;

    let titleText = 'Create';
    if (isEditMode) {
      titleText = 'Edit';
    } else if (isMigrateMode) {
      titleText = 'Migrate';
    }

    return <h4 className="create-alert-dialog-title">{titleText} Alert</h4>;
  }
}

Header.propTypes = {
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
};
